import React from 'react'
import OutBoundStats from './outBoundStats'
import Container from '../common/application_container'


const StatsIndex = () => {
    return (
        <Container icon="icon-file-stats" title="Stats" subTitle="Table">
            <OutBoundStats />
        </Container>
    )
}

export default StatsIndex